import { Button, Stack, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react'
import { AI_INTERVIEW_CREATED, AI_INTERVIEW_EVALUATED, AI_INTERVIEW_IN_PROGRESS, AI_INTERVIEW_LINK_SENT, ANALYZING, CANDIDATE_HIRED, CANDIDATE_REJECTED, IN_PERSON_INTERVIEW_SCHEDULED, SCREENING_COMPLETED, SCREENING_ERROR } from 'src/sections/job-candidate/job-candidate-status-constants';

const useStyles = makeStyles(theme => ({
    pill: {
        color: theme.palette.content.primaryBlack1,
        cursor: 'pointer',
        borderRadius: 39,
        background: theme.palette.background.primaryGrey1,
        border: `1px solid ${theme.palette.border.primaryBlack3}`,
        height: 30,
        padding: "4px 10px",
        '&:hover': {
            backgroundColor: "transparent"
        }
    },
}));

const SOURCE_UI_MAPPING = {
    "REFERRAL": "Referral",
    "LINKEDIN": "LinkedIn",
    "NAUKRI": "Naukri",
    "WELLFOUND": "Wellfound",
    "OTHER": "Other",
};

const Pill = ({ status, setFilterAPICode, setSelected, selected, FiltersMap, item }) => {
    const classes = useStyles();
    const theme = useTheme();
    return (
        <Button
            onClick={() => {
                const dumstr = `TAGS_${status}`;
                setFilterAPICode(prev => {
                    const dum = { ...prev };
                    if (selected[status]) {
                        delete (dum[FiltersMap?.filter_codes[dumstr]]);
                    }
                    else {
                        dum[FiltersMap?.filter_codes[dumstr]] = 1;
                    }
                    console.log(dum);
                    return dum;
                })
                setSelected(prev => {
                    const dum = { ...prev };
                    dum[status] = !dum[status];
                    return dum;
                })
            }}
            variant="soft"
            size="small"
            className={classes.pill}
            sx={{ border: selected[status] && `1px solid ${theme.palette.border.primaryAccent1} !important`, background: selected[status] && `${theme.palette.background.primaryAccent2} !important` }}
        >
            <Typography variant="caption">{`${status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()} (${item?.candidate_count}) `}</Typography>
        </Button>
    )
}

const TagsFilter = ({ FiltersMap, filterAPICode, setFilterAPICode, reset }) => {

    const [selected, setSelected] = useState({});
    useEffect(() => {
        setSelected({});
    }, [reset]);

    return (
        <Stack direction="row" spacing="8px" sx={{flexWrap:"wrap"}}>
            {FiltersMap?.tags && Object.values(FiltersMap?.tags)?.map((item, index) => {
                const text = Object.keys(FiltersMap?.tags)?.[index];
                return (
                    <Pill key={index} status={text} selected={selected} setSelected={setSelected} setFilterAPICode={setFilterAPICode} FiltersMap={FiltersMap} item={item} />
                )
            })
            }
        </Stack>
    )
}

export default TagsFilter